import { useEffect, useState } from 'react'

function formatDollars(cents) {
  return `$${(cents / 100).toLocaleString('en-US', { maximumFractionDigits: 0 })}`
}

export default function PaymentMethodPicker({
  finalAmountCents,
  onConfirm,
  onClose,
}) {
  const [selectedMethod, setSelectedMethod] = useState('us_bank_account')

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') onClose()
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [onClose])

  const isBank = selectedMethod === 'us_bank_account'
  const ctaLabel = isBank ? 'Continue with bank' : 'Continue with card'

  return (
    <div className="stripe-modal-backdrop" onClick={onClose}>
      <div className="pmp-modal" onClick={(e) => e.stopPropagation()}>
        <header className="pmp-header">
          <h2 className="pmp-title">
            Choose how to pay {formatDollars(finalAmountCents)}
          </h2>
          <p className="pmp-subtitle">Network+ setup fee · billed once</p>
          <div className="pmp-trust-line">
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <rect x="3" y="11" width="18" height="11" rx="2" />
              <path d="M7 11V7a5 5 0 0110 0v4" />
            </svg>
            Encrypted payment
          </div>
        </header>

        <button
          type="button"
          className={
            'pmp-tile pmp-tile-bank' +
            (isBank ? ' pmp-pulse' : ' is-unselected')
          }
          onClick={() => setSelectedMethod('us_bank_account')}
          aria-pressed={isBank}
        >
          <span className="pmp-checkmark" aria-hidden="true">
            {isBank && (
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M5 12 L9 16 L19 6" />
              </svg>
            )}
          </span>
          <div className="pmp-tile-content">
            <div className="pmp-tile-label">Bank account</div>
            <div className="pmp-tile-sublabel">Instant · Most secure</div>
          </div>
          <span className="pmp-tile-icon" aria-hidden="true">
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M3 21h18" />
              <path d="M5 21V10" />
              <path d="M19 21V10" />
              <path d="M9 21v-7" />
              <path d="M15 21v-7" />
              <path d="M2 10h20L12 3 2 10z" />
            </svg>
          </span>
          {isBank && <span className="pmp-selected-badge">✓ Selected</span>}
        </button>

        <button
          type="button"
          className={
            'pmp-tile pmp-tile-card' + (!isBank ? ' is-selected' : '')
          }
          onClick={() => setSelectedMethod('card')}
          aria-pressed={!isBank}
        >
          <span className="pmp-checkmark" aria-hidden="true">
            {!isBank && (
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M5 12 L9 16 L19 6" />
              </svg>
            )}
          </span>
          <div className="pmp-tile-content">
            <div className="pmp-tile-label">Credit or debit card</div>
            <div className="pmp-tile-sublabel pmp-brand-icons">
              <img src="/visa.svg" alt="" />
              <img src="/mastercard.svg" alt="" />
              <img src="/amex.svg" alt="" />
              <img src="/discover.svg" alt="" />
            </div>
          </div>
        </button>

        <button
          type="button"
          className="pmp-cta"
          onClick={() => onConfirm(selectedMethod)}
        >
          {ctaLabel}
          <span className="pmp-cta-arrow">→</span>
        </button>

        <div className="pmp-footer">
          <span>Powered by</span>
          <img src="/stripe-logo.png" alt="Stripe" />
        </div>
      </div>
    </div>
  )
}
